import Types from "./Types";

const INITIAL_STATE = {
  finances: {
    data: [],
    meta: {}, // For pagination extra data
  },
  financialStatus: {},
  storeTransactions: {
    data: [],
    meta: {},
  },
  isLoading: false,
};

const financialReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case Types.FINANCIAL_LOADING:
      return {
        ...state,
        isLoading: action.payload.loading, // payload structure from reduxRequest is { type, loading } or just loading? reduxRequest passes {type: ..., loading: ...} to dispatch(isLoading(...)). DashboardReducer expects payload to be boolean? reduxRequest lines 18-23: dispatch(isLoading({type, loading: true})). DashboardReducer line 13: isLoading: action.payload.
        // Wait, looking at DashboardReducer:
        // case Types.DASHBOARD_LOADING: return { ...state, isLoading: action.payload }
        // looking at reduxRequest.jsx: dispatch(isLoading({ type: loadingType, loading: true }))
        // If DashboardLoading just returns payload:
        // export const DashboardLoading = (payload) => ({ type: Types.DASHBOARD_LOADING, payload })
        // Then action.payload is { type: "dashboard", loading: true }.
        // But DashboardReducer sets isLoading: action.payload. So isLoading state becomes an object?
        // Let's re-read DashboardReducer.js
        // isLoading: action.payload
        // And reduxRequest.jsx finally block: dispatch(isLoading({ type: "", loading: false }))
        // So yes, isLoading seems to be stored as an object { type: "...", loading: ... } or maybe mistakenly treated as boolean?
        // In Financial.jsx I need to check loading state.
        // Let's assume standard behavior is to store the payload or just the loading boolean slightly extracted.
        // Actually, looking at other reducers might clarify. But keeping it simple:
        // If I follow dashboard exact pattern: isLoading: action.payload.
      };
    case Types.GET_FINANCES_SUCCESS:
      return {
        ...state,
        finances: {
          data: action.payload.data?.cart_items || [],
          meta: action.payload.extra || {},
        },
      };
    case Types.GET_FINANCIAL_STATUS_SUCCESS:
      return {
        ...state,
        financialStatus: action.payload.data || {},
      };
    case Types.GET_STORE_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        storeTransactions: {
          data: action.payload.data?.store_transactions || [],
          meta: action.payload.extra || {},
        },
      };
    default:
      return state;
  }
};

export default financialReducer;
